import { render } from "./OdsFooter.vue?vue&type=template&id=448aa211"
import script from "./OdsFooter.vue?vue&type=script&lang=js"
export * from "./OdsFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__